export default function numberTruncate() {
  function truncate(target: number | string) {
    let num = Number(target);
    const negativeCoefficient = num < 0 ? -1 : 1;
    num = Math.abs(num);
    const isQuadrillions = num >= 1e15;
    const isTrillions = num >= 1e12;
    const isBillions = num >= 1e9;
    const isThousands = num >= 1e3;
    const isMillions = num >= 1e6;
    const getNum = (num, multiplier) =>
      ((num - (num % multiplier)) / multiplier + (num % multiplier) / multiplier) * negativeCoefficient;
    const method = (multiplier: number, suffix: string) => {
      if (num % multiplier && num % multiplier !== num) {
        if (num / (multiplier * 1e2) >= 1) {
          return getNum(num, multiplier).toFixed(0) + suffix;
        } else if (num / (multiplier * 1e1) >= 1) {
          return getNum(num, multiplier).toFixed(1) + suffix;
        } else if (num / multiplier >= 1) {
          return getNum(num, multiplier).toFixed(1) + suffix;
        }
      } else {
        return negativeCoefficient * (num / multiplier) + suffix;
      }
    };

    if (isQuadrillions) {
      return method(1e15, 'Q');
    } else if (isTrillions) {
      return method(1e12, 'T');
    } else if (isBillions) {
      return method(1e9, 'B');
    } else if (isMillions) {
      return method(1e6, 'M');
    } else if (isThousands) {
      return method(1e3, 'K');
    } else {
      return num % 1 ? (num * negativeCoefficient).toFixed(1) : num * negativeCoefficient;
    }
  }
  return truncate;
}
